import React from 'react';
import PropTypes from 'prop-types';
import { StyledText, StyledTextBold } from './style';

const Text = ({ children, bold, className }) =>
  bold ? (
    <StyledTextBold className={className}>{children}</StyledTextBold>
  ) : (
    <StyledText className={className}>{children}</StyledText>
  );

Text.propTypes = {
  children: PropTypes.node,
  bold: PropTypes.bool,
  className: PropTypes.string
};

Text.defaultProps = {
  bold: false
};

export default Text;
